
import React from "react";

interface CreateProposalHeaderProjectGalleryProps {
    setProjectGalleryPopup: React.Dispatch<React.SetStateAction<{
        open: boolean;
        projectDetails?: {
            resImages?: any[];
            projectName?: string;
            _id?: string;
            imagePath?: string;
        } | null;
    }>>
    title?: string
}


export function CreateProposalHeaderProjectGallery({ title,
    setProjectGalleryPopup }: CreateProposalHeaderProjectGalleryProps) {
    return (
        <div className="container-fluid border-bottom py-3 proposal-head">
            <div className="row align-items-center">
                <>
                    <div
                        className="col-auto cursor-pointer"
                        onClick={() => setProjectGalleryPopup({ open: false, projectDetails: {} })}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M22 12L2 12"
                                stroke="#686868"
                                stroke-width="1.4"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12 22L2 12L12 2"
                                stroke="#686868"
                                stroke-width="1.4"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>

                    <label className="font-weight-semibold mb-0 font-lg">
                        {title || "Project Image Gallery"}
                    </label>
                </>
            </div>
        </div>
    );
}
